import { render, staticRenderFns } from "./BoxesWithText.vue?vue&type=template&id=5a775ad6&scoped=true&"
import script from "./BoxesWithText.vue?vue&type=script&lang=js&"
export * from "./BoxesWithText.vue?vue&type=script&lang=js&"
import style0 from "./BoxesWithText.vue?vue&type=style&index=0&id=5a775ad6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a775ad6",
  null
  
)

export default component.exports